import { useContext } from 'react';
import ContextStates from '../context/ContextStates';
import Layout from '../components/Layout';
import ListPedidos from '../components/listPedidos';


const Pedidos = () => {

	return (
		<Layout
			pagina={"Pedidos actuales"}
		>
			<div className='w-full pt-20 pb-20'>
                <ListPedidos estado={1} />
			</div>
		</Layout>
	)
}

export default Pedidos